import ApiService from "../api";

export default class ApiClientService extends ApiService {
    constructor() {
        super("/api/clients");
    }

    listar() {
        return this.get("");
    }

    criar(nome) {
        return this.post("", { nome });
    }

    excluir(id) {
        return this.delete(`/${id}`);
    }
}